<template>
  <!-- 联系我们 -->
  <div class="widthContent">
    <PageBanner url="https://www.yueyilan.com/img-yueyilan/upload/photo/zsyf/lianxi.png" title="联系我们"/>
    <div class="middleContent">
				<p class="address">杭州市·上城区·姚江路39号</p>
        <p class="phone"><img src="@/assets/phone.png" alt="图片"> 居家养老服务电话：88005421</p>
    </div>
  </div>
</template>

<script>
import PageBanner from '@/components/PageBanner'
export default {
  name: 'index',
  components:{
    PageBanner
  },
  mounted(){
      // this.initMap()
  },
  methods:{
      // initMap() {
      //       var map = new BMapGL.Map('map');
      //       var point = new BMapGL.Point(120.187693,30.226654);
      //       map.centerAndZoom(point, 15);
      //       // 创建点标记
      //       var marker = new BMapGL.Marker(point);
      //       map.addOverlay(marker);
      //       map.enableScrollWheelZoom(true)
      //       // 创建信息窗口
      //       var opts = {
      //           width: 300,
      //           height: 40,
      //           title: '杭州越易蓝科技有限公司'
      //       };
      //       var infoWindow = new BMapGL.InfoWindow('地址：浙江省杭州市上城区姚江路39号', opts);
			// // var infoWindow = new BMapGL.InfoWindow('地址：浙江省杭州市上城区姚江路29号二楼', opts);
      //       map.openInfoWindow(infoWindow, point);
      //   }
  }
}
</script>
<style lang="scss" scoped>
  .widthContent{
    .middleContent{
        margin-top: 52px;
        #map{
            width: 100%;
            height: 400px;
        }
        .address{
            font-size: 16px;
            line-height: 32px;
            margin-top: 8px;
            color: #1797E0;
        }
        .phone{
            font-size: 20px;
            line-height: 32px;
            margin-top: 32px;
            padding-bottom: 70px;
            img{
                width: 24px;
                height: 24px;
                margin-right: 12px;
            }
        }
    }
  }
  @media screen and (max-width: 1200px){
    .widthContent{
      .middleContent{
        padding: 0;
        .address,.phone{
          width: 100%;
          box-sizing: border-box;
          padding: 0 24px 40px;
        }
        .address{
          padding-bottom: 0;
          margin-top: 8px;
        }
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/Contact.vue